// Fase 9: paleta del portal cliente en un solo lugar (antes vivia inline en
// src/pages/ClientPortal/index.jsx).
// Fase C del rediseño (2026-07-07): valores alineados a la D17 aprobada —
// perla #f5f5f5 + tarjetas blancas en claro; base #121212 + #1c1c1c en
// oscuro. VERDE PROHIBIDO en el sistema: "completado/exito" usa el rol
// --done (rosa #f09e9e de relleno, rosa oscurecido como tinta legible).
//
// Son tokens JS (hex literales, no var(--x)) a proposito: el portal compone
// alphas por concatenacion (`${colors.success}12`), lo que exige valores hex
// resolubles en JS. El tema dark/light del portal es independiente del tema
// del admin (el cliente lo elige en su sesion).
//
// El ACENTO no vive aqui: sale de la configuracion del estudio via
// `resolvePortalAccentColor` (src/lib/portalAccent.js).

export const PORTAL_THEME_DARK = {
  bg: '#121212',
  surface: '#1c1c1c',
  surfaceAlt: '#232323',
  card: '#1c1c1c',
  border: 'rgba(255,255,255,.10)',
  borderSoft: 'rgba(255,255,255,.06)',
  text: '#ededed',
  muted: '#a8a8a8',
  subtle: '#8d8d8d',
  disabled: 'rgba(237,237,237,.30)',
  // Rol --done: en oscuro el rosa pleno es legible como tinta y relleno.
  done: '#f09e9e',
  doneInk: '#f09e9e',
  success: '#f09e9e',
};

export const PORTAL_THEME_LIGHT = {
  bg: '#f5f5f5',
  surface: '#ffffff',
  surfaceAlt: '#efefef',
  card: '#ffffff',
  border: 'rgba(0,0,0,.12)',
  borderSoft: 'rgba(0,0,0,.07)',
  text: '#141414',
  muted: '#555555',
  subtle: '#757575', // tinta sutil con contraste ≥4.5:1 sobre blanco
  disabled: 'rgba(20,20,20,.30)',
  // Rol --done: relleno rosa; tinta rosa oscurecido (55% rosa + 45% negro).
  done: '#f09e9e',
  doneInk: '#845757',
  success: '#845757',
};

// CTA principal del sistema (rol --cta).
//
// Era un hex fijo (#f09e9e) y por tanto una SEGUNDA autoridad de color en
// paralelo al acento configurable: cambiar `studio.accent_color` en
// Administracion no movia este boton. Ahora es un alias del token global, que
// `applyAccentColorCss` reescribe con el valor configurado.
//
// Se conservan los nombres exportados a proposito: son alias, no un token
// nuevo, y asi las nueve superficies que ya los consumen no se tocan.
// Nunca se concatenan con alfa (`${PORTAL_CTA}12`), asi que pueden ser var().
export const PORTAL_CTA = 'var(--cta, var(--accent))';
export const PORTAL_CTA_INK = 'var(--cta-ink, var(--accent-contrast))';

// Rol --info (indigo): dato / informacion / lo contractual. Nunca accion.
export const PORTAL_INFO_LIGHT = '#3d3d83';
export const PORTAL_INFO_DARK = '#9b9bd7';

export function getPortalColors(isDark = true) {
  return isDark ? PORTAL_THEME_DARK : PORTAL_THEME_LIGHT;
}
